import { render } from "./KeyPointSelection.vue?vue&type=template&id=7e020980&scoped=true"
import script from "./KeyPointSelection.vue?vue&type=script&lang=js"
export * from "./KeyPointSelection.vue?vue&type=script&lang=js"

import "./KeyPointSelection.vue?vue&type=style&index=0&id=7e020980&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e020980"]])

export default __exports__